module.exports = __webpack_public_path__ + "2d452318f9785c5c69abd37147a84d47.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/calamos.png
// module id = 1641
// module chunks = 0